import request from 'utils/request'

export const getMCAXS501InitRequest = () =>
  request({
    url: '/MCAXS501/init',
    method: 'post',
  })
